import Vue from "vue";
import Vuex from "vuex";
import currency from '@/store/modules/currency';
import user from '@/store/modules/user';
import serpDetail from "@/store/modules/serp-detail";
import SyncPlugin from "@/store/plugins/sync.js";
import { axiosTour } from "@/services/scopes/axios-tour";
import { axiosReviews } from "@/services/scopes/axios-reviews";
//import {ytVueGlobalStore} from "@/services/yt-vue-global-store";


Vue.use(Vuex);
//const ssrSerp = ytVueGlobalStore.instantGet("serp-detail");
//const ssrTours = {};
//ssrTours[ssrSerp.tourId] = ssrSerp.tour;
const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  plugins: [SyncPlugin],
  state: () => ({
    reviews: {},
    tours: {},
  }),

  actions: {
    fetchTour ({ commit }, { id, currency }) {
      // return the Promise via `store.dispatch()` so that we know
      // when the data has been fetched
      return axiosTour.getPublicTourData(id, {
        currency: currency
      }).then(data => {
        const tour = data.data.data.tour;
        commit('setTour', { id, tour })
      })
    },

    fetchReviews ({ commit }, id) {
      return axiosReviews.getReviews(id, {
        'sort[date]':'DESC',
        'limit' : 10,
      }).then(data => {
        const reviews = data.data.data;
        commit('setReviews', { id, reviews })
      })
    }
  },

  mutations: {
    setTour (state, { id, tour }) {
      Vue.set(state.tours, id, tour)
    },
    setReviews (state, { id, reviews }) {
      Vue.set(state.reviews, id, reviews)
    }
  },


  modules: {
    currency,
    user,
    serpDetail,
  },
});

export function createStore() {
  return store;
}

